import { useDispatch } from "react-redux";
import React from "react";
import {
  Grid,
  TextField,
} from "@material-ui/core";
import RegularButton from "components/CustomButtons/Button";
import { Autocomplete } from "@material-ui/lab";
import { useSearch } from "hooks/useSearch";
import { useSelector } from "react-redux";
import { setFillingOrderInputs } from "redux/actions/fillingOrder/fillingOrderActions";
import { getFillingOrders } from "redux/actions/fillingOrder/fillingOrderActions";
import { dateValidator } from "helpers/dateValidator";

const style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
};

export const FillingOrderDateInputs = () => {
  const dispatch = useDispatch();
  const { startDate, endDate, station } = useSelector(({ fillingOrder }) => fillingOrder);
  const { stationsList } = useSelector(({ companies }) => companies);
  const { setSnackbar } = useSearch();

  const handleDates = ({ target }, key) => {
    dispatch(setFillingOrderInputs(key, target.value));
  };

  const handleChangeStation = (e, v) => {
    dispatch(setFillingOrderInputs('station', v ? v : null));
  };

  const handleSubmit = (e) => {
    if(dateValidator(startDate, endDate, 31, setSnackbar))  return 
    if(!station?.id) setSnackbar('Selecciona una Planta')
    else dispatch(getFillingOrders(startDate, endDate, station?.id))
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        width: "100%",
        padding: 4,
      }}
    >
      <Grid container spacing={1}>
      <Grid item xs={12} sm={2} style={style}>
          <TextField
            label="Desde"
            type="date"
            name="startDate"
            value={startDate}
            variant="outlined"
            fullWidth
            required={true}
            onChange={(e) => handleDates(e, "startDate")}
            size="small"
          />
        </Grid>

        <Grid item xs={12} sm={2} style={style}>
          <TextField
            label="Hasta"
            type="date"
            name="endDate"
            value={endDate}
            variant="outlined"
            fullWidth
            onChange={(e) => handleDates(e, "endDate")}
            size="small"
          />
        </Grid>

        <Grid item xs={12} sm={3} style={style}>
          <Autocomplete
            id="combo-box-demo"
            options={stationsList}
            value={station}
            filterSelectedOptions
            getOptionLabel={(option) => option.label ? option.label : option.name}
            renderInput={(params) => (
              <TextField
                {...params}
                name="station"
                label="Planta"
                variant="outlined"
                size="small"
              />
            )}
            fullWidth
            onChange={(e, v) => handleChangeStation(e, v)}
            noOptionsText="No se encuentran plantas"
          />
        </Grid>
        
        <Grid
          item
          xs={12}
          sm={1}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <RegularButton color="info" onClick={handleSubmit} fullWidth>
            buscar
          </RegularButton>
        </Grid>
      </Grid>
    </form>
  );
};
